import React from 'react';

export const AdultsOnlySidePositionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M56.84 39.6201C53.1 41.7401 48.44 40.8001 44.96 38.7201C44.74 38.6001 44.52 38.4601 44.3 38.3001C43.5 32.5601 40.14 30.1601 34.86 30.2801C30.54 28.0201 25.36 27.4401 20.16 27.0201C19.78 27.0201 19.58 26.5001 19.9 26.2801C26.88 20.7401 38.02 20.9001 44.52 27.5601C48.24 31.7201 50.74 36.0001 56.5 38.0601C57.26 38.1801 57.54 39.2001 56.84 39.6201Z"
        fill="#00A6ED"
      />
      <path
        d="M9.98001 38.84C12.6531 38.84 14.82 36.6731 14.82 34C14.82 31.327 12.6531 29.16 9.98001 29.16C7.30696 29.16 5.14001 31.327 5.14001 34C5.14001 36.6731 7.30696 38.84 9.98001 38.84Z"
        fill="#FF6AA0"
      />
      <path
        d="M13.3 28.66C15.973 28.66 18.14 26.493 18.14 23.82C18.14 21.1469 15.973 18.98 13.3 18.98C10.6269 18.98 8.45996 21.1469 8.45996 23.82C8.45996 26.493 10.6269 28.66 13.3 28.66Z"
        fill="#00A6ED"
      />
      <path
        d="M55.16 45.6C48.46 50.5 37.2 48.58 35.72 39.24C35.72 39.18 35.62 38.7 35.6 38.68C35.56 38.56 35.6 38.74 35.7 38.78C30.22 37.06 22.64 38.74 17.2 35.26C16.82 35 16.7 34.48 16.96 34.1C17.12 33.86 17.36 33.74 17.6 33.72C21.1 33.22 24.32 32.08 27.96 31.34C33.32 30 42.06 29.9 43.42 37.1C43.54 37.8 43.66 38.76 43.9 39.36C45.66 43.22 50.3 43.56 55.02 44.82C55.38 44.88 55.48 45.4 55.18 45.6H55.16Z"
        fill="#FF6AA0"
      />
    </svg>
  );
};
